import { render, staticRenderFns } from "./addTag.vue?vue&type=template&id=30e2715a&scoped=true"
import script from "./addTag.vue?vue&type=script&lang=js"
export * from "./addTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e2715a",
  null
  
)

export default component.exports